import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import "./rma-status-filter-button.scss";

interface IProps {
    title: string;
    isSelected: boolean;
    disabled?: boolean;
    onClick: () => void;
}

const RmaStatusFilterButton: React.FC<IProps> = ({ title, isSelected, disabled, onClick }) => {

    return (
        <div onClick={onClick}
            className={`rma-status-filter-button ${isSelected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
        >
            <FontBody2>{title}</FontBody2>
        </div>
    )
};

export default RmaStatusFilterButton;
